import { Component } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[sui-text-icon-button]',
  templateUrl: './text-icon-button.component.html',
  styleUrl: './text-icon-button.component.scss',
})
export class TextIconButtonComponent {}
